import React, { Component } from "react";
import ButtonAlt from "../../../ButtonAlt/ButtonAlt";
import MarketCap from "./MarketCap/MarketCap";
import Revenue from "./Revenue/Revenue";
import GrossMargin from "./GrossMargin/GrossMargin";
import LiabilitiesRatio from "./LiabilitiesRatio/LiabilitiesRatio";
import Neighbors from "./Neighbors/Neighbors";
import "./AcquireesOptions.css";

class AcquireesOptions extends Component {
	render() {
		return (
			<div className="left-acquirees-options">

				<Neighbors
					query={this.props.query}
					buildSearchQuery={this.props.buildSearchQuery}
					queryTypeSingular={this.props.queryTypeSingular}
				/>
				<ButtonAlt
					label={
						this.props.moreFilters === true ? "Hide Filters" : "More Filters"
					}
					onClick={() => this.props.toggleMoreFilters()}
				/>
				{this.props.moreFilters === true && (
					<div>

						<GrossMargin
							buildSearchQuery={this.props.buildSearchQuery}
							queryTypeSingular={this.props.queryTypeSingular}
							query={this.props.query}
						/>
						<LiabilitiesRatio
							buildSearchQuery={this.props.buildSearchQuery}
							queryTypeSingular={this.props.queryTypeSingular}
							query={this.props.query}
						/>
					</div>
				)}
			</div>
		);
	}
}

//						<MarketCap
//							buildSearchQuery={this.props.buildSearchQuery}
//							queryTypeSingular={this.props.queryTypeSingular}
//						/>
//						<Revenue
//							buildSearchQuery={this.props.buildSearchQuery}
//							queryTypeSingular={this.props.queryTypeSingular}
//						/>

export default AcquireesOptions;


// WEBPACK FOOTER //
// ./src/components/Search/PanelLeft/AcquireesOptions/AcquireesOptions.js